// config/urlParams.js
export const urlParams = new URLSearchParams(window.location.search);
